var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasLocation)?_c('div',{staticClass:"jlr-number-item-style"},[_c('span',[_vm._v(_vm._s(this.loc.ClientLocationIdOnClientSite))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }